import { baseService } from "cortex/ui/src/service/base";

export const eventNameService = {
  load() {
    return baseService.get("/api/events/v3/names");
  },
};

export default eventNameService;
